module.exports = __webpack_public_path__ + "img/c07_unittechhorsemanchampion_Normal_ua.2cf95511.webp";